import { render } from "./noFirend.vue?vue&type=template&id=61b1d694&scoped=true"
import script from "./noFirend.vue?vue&type=script&lang=js"
export * from "./noFirend.vue?vue&type=script&lang=js"

import "./noFirend.vue?vue&type=style&index=0&id=61b1d694&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-61b1d694"

export default script